module.exports = __webpack_public_path__ + "img/pay.5a10e751.jpg";